<div>
	<pannel [title]="traduction.fr" *ngFor="let traduction of traductions" [expandable]="true" [folded]="true" [ngClass]= "highlightedSections.indexOf(traduction.id) > -1 ? 'highlightable' : ''" >
		<button *ngIf="traduction.traductionKey.trim().startsWith('AUTR_')" type="button" class="btn btn-primary" (click)="addOtherRiskOrImpactPdp(traduction)">
			Ajout autre Risque / Impact
		</button>
		<table class="analyse-table">
			<tr>
				<td class="table-cell" *ngIf="!traduction.traductionKey.trim().startsWith('AUTR_')">
					<table mat-table [dataSource]="traduction.activites">
						<ng-container matColumnDef="selected">
							<th mat-header-cell *matHeaderCellDef class="table-header"></th>
							<td mat-cell *matCellDef="let child">
								<mat-checkbox [(ngModel)]="child.selected" (change)="onChangeActivite(traduction.activites, traduction.riskOrImpacts, traduction.mesures)"
									class="child-cb" color="primary"></mat-checkbox>
							</td>
							<td mat-cell *matCellDef="let child">{{child.fr}}</td>
						</ng-container>
						<ng-container matColumnDef="fr">
							<th mat-header-cell *matHeaderCellDef class="table-header">Activités</th>
							<td mat-cell *matCellDef="let child"> {{child.fr}} </td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="['selected', 'fr']"></tr>
						<tr mat-row *matRowDef="let row; columns: ['selected', 'fr']"></tr>
					</table>
				</td>
				<td class="table-cell" *ngIf="!traduction.traductionKey.trim().startsWith('AUTR_')">
					<table mat-table [dataSource]="traduction.riskOrImpacts">
						<ng-container matColumnDef="selected">
							<th mat-header-cell *matHeaderCellDef class="table-header"></th>
							<td mat-cell *matCellDef="let child">
								<mat-checkbox [(ngModel)]="child.selected" [disabled]="noneSelected(traduction.activites)"
									(change)="onChangeRiskOrImpact(traduction.riskOrImpacts, traduction.mesures)"
									class="child-cb" color="primary"></mat-checkbox>
							</td>
							<td mat-cell *matCellDef="let child">{{child.fr}}</td>
						</ng-container>
						<ng-container matColumnDef="fr">
							<th mat-header-cell *matHeaderCellDef class="table-header">{{ label1 }}</th>
							<td mat-cell *matCellDef="let child"> {{child.fr}} </td>
						</ng-container>
						<tr mat-header-row *matHeaderRowDef="['selected', 'fr']"></tr>
						<tr mat-row *matRowDef="let row; columns: ['selected', 'fr']"></tr>
					</table>
				</td>
				
				<td class="table-cell" *ngIf="!traduction.traductionKey.trim().startsWith('AUTR_')">
					<table>
						<tr class="mat-header-row">
							<th class="mat-header-cell cdk-header-cell table-header"></th>
							<th class="mat-header-cell cdk-header-cell table-header">{{ label2 }}</th>
						</tr>
						<tr *ngFor="let child of traduction.mesures; let index = index" class="mat-row">
							<td class="mat-cell cell-without-bottom-border">
								<mat-checkbox [(ngModel)]="child.selected" [disabled]="noneSelected(traduction.riskOrImpacts)" 
									class="child-cb" color="primary" (change)="onChangeMesurePrevention(child, traduction, index)">
								</mat-checkbox>
							</td>
							<td class="mat-cell cell-without-bottom-border"> {{child.fr.trim() !== 'Autres' && child.traductionKey !=='MANU_MAN_MP4'? child.fr : '' }}
								<textarea *ngIf="child.fr.trim() ==='Autres'" [(ngModel)]="child.autre" class="text-autre" placeholder="Autre"></textarea>
								{{child.traductionKey ==='MANU_MAN_MP4' ? child.fr.split('--')[0] : '' }}
								<input *ngIf="child.traductionKey ==='MANU_MAN_MP4'" id="poidsfemme" name="poidsfemme" min="0" max="200" type="number"
									   class="input-poids" placeholder="15" (change)="onChangePoidsFemme(child)" [(ngModel)]="poidsFemme" />
								{{child.traductionKey ==='MANU_MAN_MP4' ? child.fr.split('--')[1] : '' }}
								<input *ngIf="child.traductionKey ==='MANU_MAN_MP4'" id="poidshomme" name="poidshomme" min="0" max="200" type="number"
									   class="input-poids" placeholder="25" (change)="onChangePoidsHomme(child)" [(ngModel)]="poidsHomme" />
								{{child.traductionKey ==='MANU_MAN_MP4' ? child.fr.split('--')[2] : '' }}
							</td>
						</tr>
					</table>
				</td>
				
				<td class="table-cell" *ngIf="!traduction.traductionKey.trim().startsWith('AUTR_')">
					<table>
						<tr class="mat-header-row">
							<th class="mat-header-cell cdk-header-cell table-header">A la charge de</th>
						</tr>
						<tr *ngFor="let child of traduction.mesures; let index = index" class="mat-row">
							<td [ngClass]="['mat-cell', (child.fr.trim() ==='Autres' ? 'responsibility-autres' : ''), 'cell-without-bottom-border']">
								<mat-checkbox [(ngModel)]="child.chargeEntrepriseUtilisatrice" [disabled]="!child.selected" 
									class="child-cb" color="primary" (change)="onChangeChargeEU(child)">EU</mat-checkbox>
								<mat-checkbox [(ngModel)]="child.chargeEntrepriseExterne" [disabled]="!child.selected" 
									class="child-cb" color="primary" (change)="onChangeChargeEE(child)">EE</mat-checkbox>
							</td>
						</tr>
					</table>
				</td>
				<!----------------------------------------------- Remplissage libre - Autre ------------------------------------------------------->
				<td class="table-cell autre" *ngIf="traduction.traductionKey.trim().startsWith('AUTR_')">
					<table>
						<th class="mat-header-cell cdk-header-cell table-header">Activités</th>
						<tr *ngFor="let child of traduction.activites">
							<td>
								<input (change)="onChangeActivite(traduction.activites, traduction.riskOrImpacts, traduction.mesures)" [maxLength]="512" 
								 	class="form-control" name="activite" id="activite" [ngClass]="'form-control'" [(ngModel)]="child.fr">
							</td>
						</tr>
					</table>
				</td>
				<td class="table-cell autre" *ngIf="traduction.traductionKey.trim().startsWith('AUTR_')">
					<table>
						<th class="mat-header-cell cdk-header-cell table-header">{{ label1 }}</th>
						<tr *ngFor="let child of traduction.riskOrImpacts">
							<td>
								<input (change)="onChangeRiskOrImpact(traduction.riskOrImpacts, traduction.mesures)" [maxLength]="512" 
								 	class="form-control" name="risk" id="risk" [ngClass]="'form-control'" [(ngModel)]="child.fr">
							</td>
						</tr>
					</table>
				</td>
				<td class="table-cell autre" *ngIf="traduction.traductionKey.trim().startsWith('AUTR_')">
					<table>
						<th class="mat-header-cell cdk-header-cell table-header">{{ label2 }}</th>
						<tr *ngFor="let child of traduction.mesures; let index = index">
							<td>
								<input (change)="onChangeMesurePrevention(child, traduction, index)" [maxLength]="512" 
							   		class="form-control" name="activite" id="activite" [ngClass]="'form-control'" [(ngModel)]="child.fr">
							</td>
						</tr>
					</table>
				</td>
				<td class="table-cell autre" *ngIf="traduction.traductionKey.trim().startsWith('AUTR_')" >
					<table>
						<th class="mat-header-cell cdk-header-cell table-header">A la charge de</th>
						<tr *ngFor="let child of traduction.mesures">
							<td class="mat-cell cdk-cell cdk-column-responsibility">
								<mat-checkbox [(ngModel)]="child.chargeEntrepriseUtilisatrice" [disabled]="child.fr.length === 0"
								  class="child-cb" color="primary" (change)="onChangeChargeEU(child)">EU</mat-checkbox>
								<mat-checkbox [(ngModel)]="child.chargeEntrepriseExterne" [disabled]="child.fr.length === 0"
								  class="child-cb" color="primary" (change)="onChangeChargeEE(child)">EE</mat-checkbox>
								<i class="fa fa-trash fa-2x text-danger" style="margin-left: 12px;" (click)="removeTraductionAutre(traduction, child.id)"></i>
							</td>
						</tr>
					</table>
				</td>
			</tr>
		</table>
	</pannel>
</div>
